import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, message, notification } from 'antd';
import moment from 'moment';
import { getFontMeApi, getOrgByClientID } from '@/services/login';
import { showBindPhoneModal, uuid } from '@/utils';

import { getVipIp, loginOutService, refreshService, setZhiyinUserTokenService } from '../services';

// todo 优化
/**
 * 作用: 检查邮箱是否符合要求
 * @param email
 */
export const emailCheck = (email: string = '') => {
  const email_pattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return email_pattern.test(email);
};

export async function getResetUserInfo() {
  // 获取用户信息,不走缓存
  const res = await getFontMeApi({}); // 知因用户
  // 更新本地信息
  if (res?.code === 200 && res.data) {
    const result = await processNoticeData(res.data); // 认证信息
    setLocalZhiyinUser(result);
    return result;
  }
  return null;
}

export async function logOut() {
  // 退出登录
  loginOutService({});
  delCookieToken();
  onShowLoginModal(); // 清空localstroage
  return true;
}

/**
 * 作用: 检验是否是邮箱
 * @param username
 */
export const isEmail = (username: string) => {
  return username.indexOf('@') >= 0;
};

/**
 * 作用: 手机号的通用正则校验
 */
export const phonePattern = /^1[23456789]\d{9}$/;

/**
 * 作用: 检查手机号是否符合正则要求
 * @param phone
 */
export const checkPhoneByPhonePattern = (phone: string = '') => {
  const checkPhoneReg = new RegExp(phonePattern);
  return phone && checkPhoneReg.test(phone);
};

export const autoCompletePhone = (phone: string = '') => {
  if (phone.indexOf('+') == -1) {
    return `+86${phone}`;
  } else {
    return phone;
  }
};

// @ts-nocheck
/**
 * 作用: 检查表单电话是否符合要求
 * @param area
 * @param phone
 * @returns {boolean}
 */
export const phoneCheck = (phone: any, area = '+86') => {
  if (
    (area == '+86' && phone && phone.length == 11) ||
    (area != '+86' && phone && phone.length >= 7 && phone.length <= 12)
  ) {
    return true;
  } else {
    return false;
  }
};

export const username_pattern = /^[\+0-9][0-9]{8,16}|\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

export const passwordPattern = /^(?=.*?[0-9]+)(?=.*?[a-zA-Z]+).{8,}$/g;

export function initModalStatus() {
  const token = getCookieToken();
  let status = false;
  const doc = document.getElementsByClassName('loginModalWrap');
  //  没有 token
  if (!token && doc.length == 0) {
    status = true;
  }

  if (status) {
    // 显示弹框
    onShowLoginModal();
  }
  return status;
}

export function getCookie(name: any) {
  let arr = document.cookie.split('; ');
  for (let i = 0; i < arr.length; i++) {
    let arr2 = arr[i].split('=');
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
}

//  判断当前域名是否为 aminer
export function getCookieDomain() {
  const domain = document.domain;
  if (domain.includes('aminer')) {
    return '.aminer.cn';
  }
  return domain;
}

// 添加或更新cookies
export function addCookie(objName: any, objValue: any) {
  let date = new Date();
  // var ms = objHours * 3600 * 1000;
  const ms = 24 * 30 * 3600 * 1000;
  date.setTime(date.getTime() + ms);

  document.cookie = `${objName}=${encodeURI(
    objValue,
  )}; expires=${date.toGMTString()}; domain=${getCookieDomain()};path=/`;
}

// 添加或更新cookies
export function delCookie(objName: any) {
  let date = new Date();
  const ms = 24 * 30 * 3600 * 1000;
  date.setTime(date.getTime() + ms);
  document.cookie = `${objName}=; expires=${date.toGMTString()}; domain=${getCookieDomain()};path=/`;
}

export let ACCESS_TOKEN = 'aminer_access_token_beta';
export let REFRESH_TOKEN = 'aminer_refresh_token_beta';

try {
  if (REACT_APP_ENV === 'prod') {
    ACCESS_TOKEN = 'aminer_access_token';
    REFRESH_TOKEN = 'aminer_refresh_token';
  }
} catch (error) {}

// 基于cookie 获取 token
export function getCookieToken() {
  let token = getCookie(ACCESS_TOKEN);
  try {
    token = decodeURI(token).replaceAll(`"`, '').replaceAll('undefined', '');
  } catch (error) {}
  return token;
}
export function setCookieToken(value: any) {
  addCookie(ACCESS_TOKEN, JSON.stringify(value));
}
export function setCookieTokens(access_token, refresh_token) {
  setCookieToken(access_token);
  addCookie(REFRESH_TOKEN, JSON.stringify(refresh_token));
}
export function delCookieToken() {
  delCookie(ACCESS_TOKEN);
  delCookie(REFRESH_TOKEN);
  // localStorage.removeItem(ACCESS_TOKEN);
  setLocalZhiyinUser();
}
export function getCookieRefreshToken() {
  let token = getCookie(REFRESH_TOKEN);
  try {
    token = decodeURI(token).replaceAll(`"`, '').replaceAll('undefined', '');
  } catch (error) {}
  return token;
}
//  设置token
export function setStorageToken(value: any) {
  if (value) {
    localStorage.setItem(ACCESS_TOKEN + 1, JSON.stringify(value));
  }
}

// 获取token
export function getStorageToken() {
  let token = localStorage.getItem(ACCESS_TOKEN + 1);
  try {
    token = decodeURI(token).replaceAll(`"`, '').replaceAll('undefined', '');
  } catch (error) {}
  return token;
}

//  设置刷新 token 时间
export function setRefreshTime(value: any) {
  localStorage.setItem('aminer_refresh_token_time', value);
}

export function getRefreshIsLoading() {
  return localStorage.getItem('refreshing') === 'true';
}

export function setRefreshLoading(bool: boolean) {
  return localStorage.setItem('refreshing', bool ? 'true' : '');
}

//  获取刷新token 时间
export function getRefreshTime() {
  let res = localStorage?.getItem('aminer_refresh_token_time') || '0';
  return parseInt(res);
}

//  设置页面停留时间
export function setPageActionTimeCount(value: any) {
  localStorage.setItem('aminer_page_count', value);
}

//  获取页面停留时间
export function getPageActionTimeCount() {
  const res = localStorage.getItem('aminer_page_count') || '0';
  return parseInt(res);
}

function getIpUserData() {
  return getVipIp()
    .then((res) => {
      const { code, data } = res || {};
      const { bind_type, ip_address, org_name } = data || {};
      if (code == 200 && data) {
        return data;
      } else {
        return null;
      }
    })
    .catch((res) => {
      return null;
    });
}

//  设置token
export function setLocalZhiyinUser(value?: any) {
  if (!value) {
    localStorage.removeItem('aminer_zhiyin_info');
    return;
  }
  localStorage.setItem('aminer_zhiyin_info', JSON.stringify(value));
}

//  设置token
export function getLocalZhiyinUser() {
  let res = localStorage.getItem('aminer_zhiyin_info');
  try {
    res = JSON.parse(res);
  } catch (error) {}
  return res ?? null;
}

//  关闭弹框
export function onCloseLoginModal() {
  // todo 同一个域名多个环境问题
  localStorage.setItem('aminerSetPwdStatus', '');
  localStorage.setItem('aminerLoginStatus', ''); // 修改local 值
}

//  打开登录弹框
export function onShowLoginModal() {
  delCookieToken();
  setLocalZhiyinUser(null);
}

//  打开设置密码弹框
export function onShowSetPwdModal() {
  localStorage.setItem('aminerSetPwdStatus', 'true');
}

//  获取登超时标识
export function getLocalModalStatus() {
  let status = localStorage.getItem('aminer_modal_status');

  return status;
}

//  清空 local
export function clearAllLocal() {
  // debugger
  localStorage?.removeItem(ACCESS_TOKEN);
  localStorage?.removeItem('aminer_zhiyin_info');
  localStorage?.removeItem('aminer_refresh_token_time');
  localStorage?.removeItem(REFRESH_TOKEN);
  localStorage?.removeItem('aminer_page_count');
  delCookieToken();
}

// 前后端约定
export const getNodeId = (key?: string) => {
  return 'bb4999d5-6a10-491f-a337-db067eb1e7f7';
};

export const fetchError = (code: any, msg?: any) => {
  let status = true;

  switch (code) {
    case 100001:
      message.error({ content: msg || '服务器开小差啦，稍后再来试一试', key: 'code100001Error' });
      status = false;
      break;
    case 413:
      message.error({ content: '请求体过大，请稍后重试', key: 'code413Error' });
      status = false;
      break;
    case 200001: // 无权限
    case 100003: // token 过期
    case 200002: // 未登录
    case 300002: // token解析错误
      // {"code":300002,"msg":"token解析错误"}
      onShowLoginModal(); //
      status = false;
      break;
    case 200006: // 其他设备登录
      localStorage.setItem('aminerOtherClientStatus', uuid());
      status = false;
      break;
    case 200007:
      showBindPhoneModal(true, { showAlert: true });
      status = false;
      break;

    default:
      break;
  }

  return status;
};

// ----权限到期提醒----
export const getTime = (time?: any) => {
  let reTime;
  try {
    reTime = time
      ? new Date(`${time.replace(/-/g, '/')} 23:59:59`).getTime()
      : new Date().getTime();
  } catch (error) {
    reTime = new Date().getTime();
  }
  return reTime;
};

export const getDays = (time: string) => {
  // return Math.ceil(moment(`${time} 23:59:59`).diff(moment(), 'seconds') / (24 * 3600));
  return moment(time, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') + 1;
};

// 只提示一次 notice
export const isShowNotice = (days: any, key: any, systemTime: any) => {
  const noticeTime = localStorage.getItem(`noticeTime${key}`);

  // if (days <= 3 && noticeTime != '3') { // 0~3(包含3) 提示一次
  //   localStorage.setItem(`noticeTime${key}`, "3");
  //   return true
  // }

  // if (days <= 7 && noticeTime != '7') { // 3~7(包含7) 提示一次
  //   localStorage.setItem(`noticeTime${key}`, "7");
  //   return true
  // }

  // if (days <= 30 && noticeTime != '30') { // 7~30(包含30) 提示一次
  //   localStorage.setItem(`noticeTime${key}`, "30");
  //   return true
  // }

  // 小于30天，每天登录提示一次
  if (days <= 30 && noticeTime != systemTime) {
    // 7~30(包含30) 提示一次
    localStorage.setItem(`noticeTime${key}`, systemTime);
    return true;
  }
  return false;
};

//  权限到期数据处理
export async function processNoticeData(resData: any) {
  // const { permission_type } = res.data;
  // let __isVip = false;// 是否vip
  const systemTime = resData.system_time.slice(0, 10);

  const [expire_time, orgExpireTime, pay_time, current_time] = [
    getTime(resData.expire_time),
    getTime(resData.orgExpireTime),
    getTime(resData.pay_time),
    getTime(systemTime), // 取系统时间
  ];
  const isExpire = current_time > expire_time;
  // 到期提醒
  let days = 0;
  let role = 3; // role, 1:机构管理员，2:机构普通用户， 3:非机构用户
  let isNotice = false;

  // 未到期
  if (!isExpire) {
    if (resData.is_bind_org === 1) {
      // 绑定机构了
      days = getDays(resData.orgExpireTime); //失效时间
      role = 2;
      if (resData.role === 'admin') {
        // 机构管理员
        role = 1;
      }
    }

    // 未绑定机构（普通用户） || 机构已过期
    if (resData.is_bind_org !== 1 || days <= 0) {
      role = 3;
      days = getDays(resData.expire_time); //失效时间
    }

    // days = 30

    // let a = getDays(resData.registryTime);
    // 非当天
    if (getDays(resData.registryTime) !== 1) {
      isNotice = isShowNotice(days, resData.userId, systemTime);

      // const noticeMap = JSON.parse(localStorage.getItem('noticeMap') || '{}');
      // const noticeMapRole = +(localStorage.getItem('noticeMapRole') || '0');

      // const userNoticeTime = noticeMapRole === role ? noticeMap[resData.userId] ?? -1 : -1;

      // localStorage.setItem('noticeMap', JSON.stringify({ [resData.userId]: days }));
      // localStorage.setItem('noticeMapRole', role.toString());

      // if (days > 0) {
      //   // 0~3(包含3) 提示一次
      //   if (days <= 3) {

      //   }
      //   // 3~7(包含7) 提示一次
      //   // 7~30(包含30) 提示一次
      //   // localStorage.setItem('noticeMap', JSON.stringify({ [resData.userId]: days }));
      //   // localStorage.setItem('noticeMapRole', role.toString());
      // }

      // if (days > 0) {
      //   const set1 = [
      //     [() => days <= 3, () => (isNotice = userNoticeTime > 3 || userNoticeTime <= 0)],
      //     [() => days <= 7, () => (isNotice = userNoticeTime > 7 || userNoticeTime <= 3)],
      //     [() => days <= 30, () => (isNotice = userNoticeTime > 30 || userNoticeTime <= 7)],
      //   ];

      //   set1.some(([condition, set]) => {
      //     if (condition()) {
      //       set();
      //       return true;
      //     }
      //   });
      // }
    }
  } else {
    localStorage.setItem('noticeMap', JSON.stringify({ [resData.userId]: -1 })); // 失效
  }

  // 类型为2 而且支付时间大于当前时间
  // if (permission_type == 2 && pay_time > current_time) {
  //   __isVip = true
  // }

  // if (permission_type == 1) { // 为 1 肯定不是vip
  //   __isVip = false
  // }

  let ipAuth = null;
  // is_bind_org = 2的时候未绑定机构
  if (
    expire_time < current_time ||
    (resData.role?.includes('admin') && resData.org_bind_type == 2)
  ) {
    // 请求是否是内网权限类型
    const res = await getIpUserData();
    if (res) {
      ipAuth = res;
    }
  }

  let idAuth = null;
  if (
    expire_time < current_time ||
    (resData.role?.includes('admin') && resData.org_bind_type == 3)
  ) {
    const res = await getOrgByClientID();
    if (res?.code === 200) {
      idAuth = res.data;
    }
  }
  // const OrgByClientID =
  const resultData = {
    ...resData,
    __isExpire: isExpire, // 是否过期 false 未到期
    __days: days, // 还剩多少天到期
    __role: role, // 用户类别
    __isNotice: isNotice, // 是展示notice
    __isVip: expire_time >= current_time || !!ipAuth || !!idAuth, //是否有vip权限 也就是是否可以访问ip权限的人
    __ipAuth: ipAuth, // 有效期大于当前时间 vip
    __idAuth: idAuth, // 有效期大于当前时间 vip
  };
  return resultData;
}

// role, 1:机构管理员
// role, 2:机构普通用户
// role, 3:非机构用户
export const openNoitce = (data: any, onClickPay: any) => {
  if (!onClickPay || !data) {
    // 数据格式不满足
    return;
  }
  const { __days: days, __role: role } = data;
  // 弹框提示
  if (!data.__isNotice) {
    return;
  }

  // 更新用户状态
  let userInfo = getLocalZhiyinUser();
  userInfo['__isNotice'] = false;
  setLocalZhiyinUser(userInfo);

  switch (role) {
    case 1:
      notification.open({
        message: '权限到期提醒',
        key: '_notice_',
        duration: 6,
        description: (
          <div>
            <span>
              <span style={{ color: '#ea0000' }}>机构使用权限</span>已不足{days}
              天，为不耽误您的使用，请及时续费。
            </span>
            <div style={{ textAlign: 'right' }}>
              <Button
                type="link"
                onClick={() => {
                  // setRelations({ open: true, closable: false });
                  notification.close('_notice_');
                  onClickPay?.();
                }}
              >
                立即续费
              </Button>
            </div>
          </div>
        ),
        icon: <ExclamationCircleFilled style={{ color: '#E24F48', fontSize: 21 }} />,
      });
      break;
    case 2:
      notification.open({
        key: '_notice_',
        duration: 6,
        message: '权限到期提醒',
        description: (
          <span>
            <span style={{ color: '#ea0000' }}>机构使用权限</span>已不足{days}
            天，为不耽误您的使用，请及时续费。
          </span>
        ),
        icon: <ExclamationCircleFilled style={{ color: '#E24F48', fontSize: 21 }} />,
      });
      break;
    case 3:
      notification.open({
        key: '_notice_',
        message: '权限到期提醒',
        duration: 6,
        description: (
          <div>
            <span>系统使用权限已不足{days}天，为不耽误您的使用，请及时续费。</span>
            <div style={{ textAlign: 'right' }}>
              <Button
                type="link"
                onClick={() => {
                  notification.close('_notice_');
                  onClickPay?.();
                  // setRelations({ open: true, closable: false });
                }}
              >
                立即续费
              </Button>
            </div>
          </div>
        ),
        icon: <ExclamationCircleFilled style={{ color: '#E24F48', fontSize: 21 }} />,
      });
      break;
  }
};

// 刷新tokne
export const onRefreshTokenAsync = async () => {
  const { message: msg, data } = await refreshService({
    refresh_token: getCookieRefreshToken(),
  });
  if (msg == 'success') {
    const { access_token, refresh_token } = data;
    await setZhiyinUserTokenService({ token: access_token }); // 将token更新到知因系统
    setStorageToken(access_token);
    setCookieTokens(access_token, refresh_token);
    setRefreshTime(Date.now());
    return data;
  } else {
    return null;
  }
};

export async function setTokenApi(token) {
  if (!token) return;
  const res = await setZhiyinUserTokenService({ token }); // 将token更新到知因系统
  setRefreshTime(Date.now());
  setStorageToken(token);
  return res;
}

// setToken
export async function setTokenFn() {
  const token = getCookieToken();
  const local_access_token = getStorageToken();
  if (local_access_token === token) return;
  const res = await setTokenApi(token);
  return res;
}
